import axios from "axios";

export default (lang = "en") => {
  axios.defaults.headers.common["Accept-Language"] = lang;
};
